<div class="with-floating-button">
    <div class="content">
        <page-header [title]="'admin.comptabilite.comptesBancaires.title' | translate" [listeItems]="listeTabItems" [selectedIndex]="selectedIndex"></page-header>

        <router-outlet></router-outlet>
    </div>
</div>
